/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Location } from './';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    formattedAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    administrativeAreaLevel1?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    administrativeAreaLevel1Code?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    administrativeAreaLevel2?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    administrativeAreaLevel2Code?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    administrativeAreaLevel3?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    administrativeAreaLevel3Code?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    administrativeAreaLevel4?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    administrativeAreaLevel4Code?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    region?: string;
    /**
     * 
     * @type {Location}
     * @memberof Address
     */
    loc?: Location;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
    return true;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if (json == null) {
        return json;
    }
    return {
        
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'street': json['street'] == null ? undefined : json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'city': json['city'] == null ? undefined : json['city'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'administrativeAreaLevel1': json['administrativeAreaLevel1'] == null ? undefined : json['administrativeAreaLevel1'],
        'administrativeAreaLevel1Code': json['administrativeAreaLevel1Code'] == null ? undefined : json['administrativeAreaLevel1Code'],
        'administrativeAreaLevel2': json['administrativeAreaLevel2'] == null ? undefined : json['administrativeAreaLevel2'],
        'administrativeAreaLevel2Code': json['administrativeAreaLevel2Code'] == null ? undefined : json['administrativeAreaLevel2Code'],
        'administrativeAreaLevel3': json['administrativeAreaLevel3'] == null ? undefined : json['administrativeAreaLevel3'],
        'administrativeAreaLevel3Code': json['administrativeAreaLevel3Code'] == null ? undefined : json['administrativeAreaLevel3Code'],
        'administrativeAreaLevel4': json['administrativeAreaLevel4'] == null ? undefined : json['administrativeAreaLevel4'],
        'administrativeAreaLevel4Code': json['administrativeAreaLevel4Code'] == null ? undefined : json['administrativeAreaLevel4Code'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'region': json['region'] == null ? undefined : json['region'],
        'loc': json['loc'] == null ? undefined : LocationFromJSON(json['loc']),
    };
}

export function AddressToJSON(value?: Address | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'formattedAddress': value['formattedAddress'],
        'street': value['street'],
        'street2': value['street2'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'administrativeAreaLevel1': value['administrativeAreaLevel1'],
        'administrativeAreaLevel1Code': value['administrativeAreaLevel1Code'],
        'administrativeAreaLevel2': value['administrativeAreaLevel2'],
        'administrativeAreaLevel2Code': value['administrativeAreaLevel2Code'],
        'administrativeAreaLevel3': value['administrativeAreaLevel3'],
        'administrativeAreaLevel3Code': value['administrativeAreaLevel3Code'],
        'administrativeAreaLevel4': value['administrativeAreaLevel4'],
        'administrativeAreaLevel4Code': value['administrativeAreaLevel4Code'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'region': value['region'],
        'loc': LocationToJSON(value['loc']),
    };
}

